import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class FrameworkLayersSources extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'FrameworkLayersSources'
  // Define default properties here
  static instanceDefaults () {
    return {
      frameworkId: null,
      layerSourceId: null,
      settings: {},
    }
  }
}
const servicePath = 'framework-layers-sources'
const servicePlugin = makeServicePlugin({
  Model: FrameworkLayersSources,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
